import React, { useContext } from 'react';
import defaultLocales from '../../../locales';
import LanguageConfig from '../../../constants/languages';
var LocaleContext = /*#__PURE__*/React.createContext(undefined);
var DEFAULT_LOCALE = 'en';
var LANGUAGES = LanguageConfig.LANGUAGES;
var LocaleProvider = function LocaleProvider(_ref) {
  var locale = _ref.locale,
    locales = _ref.locales,
    region = _ref.region,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: {
      locale: locale,
      locales: locales,
      region: region
    }
  }, children);
};
var useLocale = function useLocale() {
  var _ref3;
  var localeContext = useContext(LocaleContext);
  var _ref2 = localeContext || {},
    locale = _ref2.locale,
    locales = _ref2.locales,
    region = _ref2.region;
  var LANG = locale || (LANGUAGES === null || LANGUAGES === void 0 ? void 0 : (_ref3 = LANGUAGES[region]) === null || _ref3 === void 0 ? void 0 : _ref3.key) || DEFAULT_LOCALE;
  var defaultStrings = Object.assign(LANG && defaultLocales[LANG] || {}, locales);
  return {
    locale: locale,
    region: region,
    trans: function trans(key) {
      return key ? defaultStrings[key] : defaultStrings;
    }
  };
};
export { LocaleProvider, LocaleContext, useLocale };